export const emailConstants = {
    GET_EMAIL_REQUEST: 'GET_EMAIL_REQUEST',
    GET_EMAIL_SUCCESS: 'GET_EMAIL_SUCCESS',
    GET_EMAIL_FAILURE: 'GET_EMAIL_FAILURE',

    GETALL_EMAIL_REQUEST: 'GETALL_EMAIL_REQUEST',
    GETALL_EMAIL_SUCCESS: 'GETALL_EMAIL_SUCCESS',
    GETALL_EMAIL_FAILURE: 'GETALL_EMAIL_FAILURE',

    UPDATE_EMAIL_REQUEST: 'UPDATE_EMAIL_REQUEST',
    UPDATE_EMAIL_SUCCESS: 'UPDATE_EMAIL_SUCCESS',
    UPDATE_EMAIL_FAILURE: 'UPDATE_EMAIL_FAILURE',

    SEND_TEST_REQUEST: 'SEND_TEST_REQUEST',
    SEND_TEST_SUCCESS: 'SEND_TEST_SUCCESS',
    SEND_TEST_FAILURE: 'SEND_TEST_FAILURE',


    EMAIL_SENT: 'EMAIL_SENT',
    UPDATE_EMAIL_ELEMENT: 'UPDATE_EMAIL_ELEMENT',
    SELECT_EMAIL_ELEMENT: 'SELECT_EMAIL_ELEMENT',
    DESELECT_EMAIL_ELEMENT: 'DESELECT_EMAIL_ELEMENT',
    SOFT_UPDATE_EMAIL: 'SOFT_UPDATE_EMAIL',
    REMOVE_EMAIL_ELEMENT: 'REMOVE_EMAIL_ELEMENT'
};